import NewCandidateDialog from "./NewCandidateDialog";

export default NewCandidateDialog;
